import { signal } from "../../utils/signal";

/**
 * Cross-tree trigger for the app-level <SignInModal/> that lives in App.tsx.
 *
 * Components rendered deep in the route tree (e.g. the pricing-page tier
 * CTAs) can call openSignInModal() to pop the sign-in modal in place instead
 * of navigating to the standalone /login page. App.tsx subscribes via
 * useSignalValue and consumes the request as an edge — it flips the signal
 * back to false right after opening the modal — so a second CTA click later
 * re-opens it cleanly.
 */
export const signInModalSignal = signal(false);

export function openSignInModal(): void {
  signInModalSignal.value = true;
}
